export default __webpack_public_path__ + "static/media/grow.ed856bf2.svg";